export default {
    invalidEmailFormat: 'Invalid email format',
    sendScreenshot: 'Send screenshot',
    selectedTemplate: 'Selected template',
    createNew: 'Create new template',
    selectExisting: 'Select existing template',
    templateName: 'Template name',
    setUserIdAsReplyTo: 'Use user login as reply-to address in email',
    LoginBlockEmailAdressHint: 'Make sure you enable in login block the option to allow only emails as input.',
    invalidEmailAddress: 'Invalid email address',
}